export default __webpack_public_path__ + "static/media/navBarLogo.0e831b29.svg";